package team.platforma.multiplatform_material_extension.calendar.core.core_ui

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalDate
import kotlinx.datetime.Month
import kotlinx.datetime.TimeZone
import kotlinx.datetime.number
import kotlinx.datetime.todayIn
import team.platforma.multiplatform_material_extension.calendar.core.CALENDAR
import team.platforma.multiplatform_material_extension.calendar.style.CalendarViewStyle
import team.platforma.multiplatform_material_extension.calendar.utils.CalendarRange
import team.platforma.multiplatform_material_extension.calendar.utils.daysInMonth
import team.platforma.multiplatform_material_extension.scrollbar.VerticalScrollIndicator
import team.platforma.multiplatform_material_extension.util.IndicatorPadding
import team.platforma.multiplatform_material_extension.util.verticalScrollbar

@Composable
internal fun ChangeMonthView(
    selectedDate: LocalDate,
    onDateSelected: (LocalDate) -> Unit,
    calendarRange: CalendarRange
) {
    val months = Month.entries
    val dateNow: LocalDate = Clock.System.todayIn(TimeZone.currentSystemDefault())

    val selectedMonthIndex = months.indexOfFirst { month -> month == selectedDate.month }
    val lazyListState = rememberLazyListState()



    LaunchedEffect(selectedMonthIndex) {
        if (selectedMonthIndex >= 0) {
            lazyListState.scrollToItem(selectedMonthIndex)
        }
    }

    VerticalScrollIndicator(
        state = lazyListState
    ) {
        LazyColumn(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(8.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
            state = lazyListState
        ) {

            items(months) { month ->

                val startOfMonth = LocalDate(selectedDate.year, month.number, 1)
                val endOfMonth = LocalDate(
                    selectedDate.year,
                    month.number,
                    daysInMonth(selectedDate.year, month.number)
                )

                val isMonthInRange =
                    (startOfMonth in calendarRange.max..calendarRange.min) || (endOfMonth in calendarRange.max..calendarRange.min)

                Box(
                    modifier = Modifier.fillParentMaxWidth()
                        .padding(4.dp),
                    contentAlignment = Alignment.Center

                ) {

                    Box(
                        modifier = Modifier.fillMaxWidth()
                            .padding(horizontal = 16.dp)
                            .clip(CalendarViewStyle.dateStyle().shape)
                            .background(
                                color = if (month == selectedDate.month) CalendarViewStyle.dateStyle().checkedDateBackground else CalendarViewStyle.dateStyle().defaultDateBackground,
                                shape = CalendarViewStyle.dateStyle().shape
                            )
                            .border(
                                width = CalendarViewStyle.dateStyle().borderWidth,
                                color = if (month == selectedDate.month || month == dateNow.month) CalendarViewStyle.dateStyle().checkedDateBorder else CalendarViewStyle.dateStyle().defaultDateBorder,
                                shape = CalendarViewStyle.dateStyle().shape
                            )
                            .clickable(
                                enabled = isMonthInRange
                            ) {
                                val resultDate = LocalDate(
                                    selectedDate.year,
                                    month.number,
                                    selectedDate.dayOfMonth.coerceAtMost(
                                        daysInMonth(selectedDate.year, month.number)
                                    )
                                )
                                val adjustedDate =
                                    resultDate.coerceIn(calendarRange.max, calendarRange.min)

                                onDateSelected(adjustedDate)
                            },
                        contentAlignment = Alignment.Center
                    ) {
                        Text(
                            modifier = Modifier.padding(4.dp),
                            text = CALENDAR().getMonthByNumber(month.number),
                            style = MaterialTheme.typography.bodyLarge,
                            color = if (isMonthInRange) {
                                if (month == selectedDate.month) {
                                    CalendarViewStyle.dateStyle().checkedDateText
                                } else {
                                    CalendarViewStyle.dateStyle().enabledDateText
                                }
                            } else {
                                CalendarViewStyle.dateStyle().disableDateText
                            }
                        )
                    }
                }

            }

        }
    }


}
